// import { TextProps } from "../data";
import { PropsWithChildren } from "react";
import { TextProps } from "../data";
import { fontWeightEnum } from "../enumerations/fontWeightEnum";
import styles from "./style.module.scss";

const H1: React.FC<
  PropsWithChildren & TextProps & React.HTMLAttributes<HTMLHeadingElement>
> = ({
  children,
  weight = "normal",
  color = "rgba(0, 0, 0, 0.88)",
  ...props
}) => {
  return (
    <h1
      {...props}
      className={`${styles.h1} ${props.className}`}
      style={{
        fontWeight: fontWeightEnum[weight],
        color: color,
        ...props.style,
      }}
    >
      {children}
    </h1>
  );
};

export default H1;
